const toggler = "_rstba63s3";

export { toggler };
import "./_toggler.styles.linaria.module.css";
//# sourceMappingURL=_toggler.styles.js.map
